export const userConstants = {
    GET_USERS_DATA_REQUEST: "GET_USERS_DATA_REQUEST",
    GET_USERS_DATA_SUCCESS: "GET_USERS_DATA_SUCCESS",
    GET_USERS_DATA_FAILURE: "GET_USERS_DATA_FAILURE",
  };